import { Palette, Sizes } from "./palette";
import { createTheme } from '@uiw/codemirror-themes';
import { tags as t } from '@lezer/highlight';

export const ThirdBtnSx = {
    color: Palette.textColorPrimary,
    textTransform: "none",
    fontSize: Sizes.textPrimary,
    lineHeight: 1
}

export const PageHeaderSx = {
    color: Palette.textColorPrimary,
    fontSize: Sizes.pageTitle,
    textTransform: "none",
    wordBreak: "break-all",
}

export const PageSecondHeaderSx = {
    color: Palette.textColorPrimary,
    fontSize: Sizes.pageSecondTitle,
    marginBottom: "5px",
    textTransform: "none",
    wordBreak: "break-all",
}

export const PageThirdHeaderSx = {
    color: Palette.textColorPrimary,
    fontSize: Sizes.pageThirdTitle,
    marginBottom: "5px",
    textTransform: "none",
    wordBreak: "break-all",
}

export const PageDescriptionSx = {
    color: Palette.textColorSecondary,
    fontSize: Sizes.textPrimary,
    marginBottom: "5px",
    wordBreak: "break-all",
}

export const FlexBoxInline = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "5px"
}

export const ListItemSx = {
    padding: "5px",
    "&:hover": {
        background: Palette.leftPanelItemBackgroundHover
    }
}

export const FlexBoxColumn = {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "5px"
}

export const TabSx = {
    color: Palette.textColorSecondary,
    fontSize: Sizes.textPrimary,
    textTransform: "none"
}

export const LinkSx = {
    fontSize: Sizes.textPrimary,
    textTransform: "none",
    color: Palette.btnPrimary,
    textDecoration: "none",
    cursor: "pointer",
    "&:hover": {
        textDecoration: "underline"
    },
    "&:active": {
        textDecoration: "underline"
    }
};

export const LinkSxSmall = {
    fontSize: Sizes.textSecondary,
    textTransform: "none",
    color: Palette.btnPrimary,
    textDecoration: "none",

    "&:hover": {
        textDecoration: "underline"
    },
    "&:active": {
        textDecoration: "underline"
    }
};


export const PrimaryBtnSx = {
    fontSize: Sizes.textPrimary,
    textTransform: "none",
    border: "1px solid " + Palette.btnPrimary,
    background: "none",
    color: Palette.btnPrimary,
    "&:hover": {
        background: Palette.btnPrimaryHover,
    },
    "&:active": {
        background: Palette.btnPrimaryActive,
    },
    "&.Mui-disabled": {
        border: "1px solid " + Palette.btnDisabled,
    }

};

export const PrimaryBtnBorderlessSx = {
    fontSize: Sizes.textPrimary,
    textTransform: "none",
    border: "none",
    background: "none",
    color: Palette.btnPrimary,
    "&:hover": {
        background: Palette.btnPrimaryHover,
    },
    "&:active": {
        background: Palette.btnPrimaryActive,
    },
    "&.Mui-disabled": {
        border: "none",
        color: Palette.btnDisabled,
    }
};

export const PrimarySupportBtnSx = {
    fontSize: Sizes.textPrimary,
    textTransform: "none",
    border: "1px solid " + Palette.btnPrimary,
    background: Palette.btnPrimary,
    color: Palette.textColorPrimaryContrast,
    width: 42,
    height: 42,
    "&:hover": {
        background: Palette.btnFillPrimaryHover,
    },
    "&:active": {
        background: Palette.btnFillPrimaryActive,
    },
    "&.Mui-disabled": {
        border: "1px solid " + Palette.btnDisabled,
    }

};

export const SecondaryBtnSx = {
    fontSize: Sizes.textPrimary,
    textTransform: "none",
    border: "1px solid " + Palette.btnSecondary,
    background: "none",
    padding: "6px 8px",
    color: Palette.btnSecondary,
    "&:hover": {
        background: Palette.btnSecondaryHover,
    },
    "&:active": {
        background: Palette.btnSecondaryActive,
    },
    "&.Mui-disabled": {
        border: "1px solid " + Palette.btnDisabled,
    }

};

export const OAuthBtnSx = {
    fontSize: Sizes.textPrimary,
    textTransform: "none",
    border: "1px solid " + Palette.btnOAuthBorder,
    padding: "6px 8px",
    color: Palette.btnOAuthText,
    bacgroundColor: Palette.btnOAuthBackground,
    "&:hover": {
        background: Palette.btnOAuthBackgroundHover,
    },
    "&:active": {
        background: Palette.btnOAuthBackgroundActive,
    },
    "&.Mui-disabled": {
        border: "1px solid " + Palette.btnDisabled,
    }

};

export const ArrowBtnSx = {
    fontSize: Sizes.textPrimary,
    textTransform: "none",
    background: "none",
    padding: "6px 6px",
    borderRadius: "4px",
    color: Palette.btnSecondary,
    "&:hover": {
        background: Palette.btnSecondaryHover,
    },
    "&:active": {
        background: Palette.btnSecondaryActive,
    },
    "&.Mui-disabled": {
        border: "1px solid " + Palette.btnDisabled,
    },
    "& .MuiTouchRipple-root": {
        display: "none"
    }
};

export const RemoveBtnSx = {
    fontSize: Sizes.textPrimary,
    textTransform: "none",
    border: "1px solid " + Palette.btnRemove,
    background: "none",
    color: Palette.btnRemove,
    "&:hover": {
        background: Palette.btnRemoveHover,
    },
    "&:active": {
        background: Palette.btnRemoveActive,
    },
    "&.Mui-disabled": {
        border: "1px solid " + Palette.btnDisabled,
    }

};

export const BadgeBoxSx = {
    background: "#99cafa",
    padding: "2px 8px",
    borderRadius: "13px",
    fontSize: Sizes.textSecondary
}

export const InputBaseSx = {
    margin: "10px 0",
    ".MuiInputBase-root": {
        fontSize: Sizes.textPrimary,
        color: Palette.textColorPrimary,
    },
    ".MuiFormLabel-root": {
        fontSize: Sizes.textPrimary,
        color: Palette.textColorSecondary,
    }
}

export const CodeMirrorStyles = {
    fontSize: Sizes.textSecondary,
}

export const CodeMirrorTheme = createTheme({
    theme: 'light',
    settings: {
        background: Palette.backgroundColorPrimary, // Soft light background
        backgroundImage: '',
        foreground: '#333333', // Primary text color
        caret: '#007acc', // Caret color (blue for visibility)
        selection: '#84bbff ', // Light blue for selection
        selectionMatch: '#dbeafe', // Slightly darker blue for matches
        gutterBackground: '#f9f9fb', // Match editor background
        gutterForeground: '#a0aec0', // Neutral gray for line numbers
    },
    styles: [
        { tag: t.comment, color: '#718096' }, // Neutral gray for comments
        { tag: t.variableName, color: '#2b6cb0' }, // Deep blue for variables
        { tag: [t.string, t.special(t.brace)], color: '#d69e2e' }, // Gold for strings
        { tag: t.number, color: '#dd6b20' }, // Orange for numbers
        { tag: t.bool, color: '#d53f8c' }, // Pink for booleans
        { tag: t.null, color: '#b83280' }, // Dark pink for null
        { tag: t.keyword, color: '#805ad5', fontWeight: 'bold' }, // Purple for keywords
        { tag: t.operator, color: '#2c5282' }, // Blue for operators
        { tag: t.className, color: '#2a69ac', fontWeight: 'bold' }, // Bold blue for class names
        { tag: t.definition(t.typeName), color: '#e53e3e' }, // Red for type definitions
        { tag: t.typeName, color: '#dd6b20' }, // Orange for type names
        { tag: t.angleBracket, color: '#319795' }, // Teal for brackets
        { tag: t.tagName, color: '#0d9488' }, // Aqua for tags
        { tag: t.attributeName, color: '#805ad5', fontStyle: 'italic' }, // Purple italic for attributes
    ],
});

const iOSBoxShadow =
    '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)';

export const SliderSx = {
    color: '#007bff',
    height: 5,
    padding: '8px 0',
    '& .MuiSlider-thumb': {
        height: 14,
        width: 14,
        backgroundColor: Palette.btnPrimary,
        boxShadow: '0 0 2px 0px rgba(0, 0, 0, 0.1)',
        '&:focus, &:hover, &.Mui-active': {
            boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.1)',
            backgroundColor: Palette.btnPrimary,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                boxShadow: iOSBoxShadow,
            },
        },
        '&:before': {
            boxShadow:
                '0px 0px 1px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 1px 0px rgba(0,0,0,0.12)',
        },
        '&:after': {
            width: "100%",
            height: "100%"
        },
    },
    '& .MuiSlider-valueLabel': {
        fontSize: 12,
        fontWeight: 'normal',
        top: -6,
        backgroundColor: 'unset',
        color: Palette.btnPrimary,
        '&::before': {
            display: 'none',
        },
        '& *': {
            background: 'transparent',
            color: '#000',
        },
    },
    '& .MuiSlider-track': {
        border: 'none',
        height: 5,
        backgroundColor: '#79a9f0',
    },
    '& .MuiSlider-rail': {
        opacity: 0.5,
        boxShadow: 'inset 0px 0px 4px -2px #000',
        backgroundColor: '#d0d0d0',
    },
    '& .MuiSlider-mark': {
        backgroundColor: 'transparent'
    }
}

export const DateTimeSx = {
    ".react-datepicker": {
        background: Palette.backgroundColorCard,
        border: "1px solid " + Palette.borderColorPrimary,
    },
    ".react-datepicker__header": {
        borderBottom: "1px solid " + Palette.borderColorPrimary,
        background: Palette.backgroundColorPrimary,
    },
    ".react-datepicker__current-month": {
        color: Palette.textColorPrimary,
        fontSize: Sizes.textPrimary,
    },
    ".react-datepicker__day-name, .react-datepicker__day": {
        color: Palette.textColorPrimary,
        fontSize: Sizes.textSecondary,
    },
    ".react-datepicker__day:hover": {
        backgroundColor: Palette.leftPanelItemBackgroundHover,
    },
    ".react-datepicker__day--outside-month": {
        color: Palette.textColorSecondary,
    },
    ".react-datepicker__day--selected": {
        backgroundColor: Palette.btnPrimary,
        color: Palette.textColorPrimaryContrast,
    },
    ".react-datepicker__day--selected:hover": {
        backgroundColor: Palette.btnFillPrimaryHover,
    },
    ".react-datepicker__triangle": {
        stroke: Palette.borderColorPrimary,
    }
}

export const SelectMenuProps = {
    slotProps: {
        paper: {
            sx: {
                minWidth: 'var(--select-width)',
                backgroundColor: Palette.backgroundColorPrimary,
            },
        },
    },
};

export const SelectMenuItemSx = {
    fontSize: Sizes.textPrimary,
    color: Palette.textColorPrimary
}

export const SelectMenuSubTitleSx = {
    background: Palette.backgroundColorPrimary,
    fontSize: Sizes.textPrimary,
    color: Palette.textColorPrimary,
    fontWeight: "bold",
}

export const TooltipSlotProps = {
    tooltip: { sx: { backgroundColor: "rgb(239 241 243)", boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)", color: Palette.textColorPrimary } },
    arrow: { sx: { color: "rgb(239 241 243)", fontSize: 20 } }
}